<template>
  <v-app dark>
    <v-navigation-drawer
      app
      v-model="drawer">
      <v-list>
        <v-list-tile
          v-for="menu in menus"
          :key="menu.title"
          :to="{path: menu.link}">
          <v-list-tile-action>
            <v-icon>{{menu.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ menu.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app>
      <v-toolbar-side-icon
        @click="drawer = !drawer">
      </v-toolbar-side-icon>
      <v-toolbar-title>AGK欠食システム</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <v-alert v-show="error" type="error">
          {{error}}
        </v-alert>
        <router-view v-show="!error"></router-view>
      </v-container>
    </v-content>

    <v-footer app>
      <v-layout
        justify-center
        row
        wrap
      >
        <v-flex
          py-3
          text-xs-center
          xs12
        >
          <p> © 2019 愛知学生会館 </p>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  created(){
    if(this.$route.query.user)
      localStorage.user = this.$route.query.user
    if(!localStorage.user){
      this.error="ログイン情報が不足しています"
    }
  },
  name: 'App',
  data () {
    return {
      drawer: false,
      error: "",
      menus: [
        {
          title:"TOP",
          icon: "home",
          link: "/",
        },
        {
          title:"欠食確認、変更",
          icon: "restaurant",
          link: "meal_skipping",
        },
        {
          title: "欠食連続申請",
          icon: "edit",
          link: "serial",
        },
        {
          title: "外泊申請",
          icon: "hotel",
          link: "travel",
        },
        {
          title: "外泊申請一覧",
          icon: "hotel",
          link: "travel_list",
        },
/*        {
          title: "欠食売買",
          icon: "autorenew",
          link: "trade",
        },*/
      ],
    }
  }
}
</script>
